const translations = {
    es: {
        "show-on-map": "Ver en el mapa",
        "delete": "Borrar",
        "delete-question-title": "Se borrará la ruta",
        "delete-question-text": "La ruta y sus puntos se borrarán. No se puede deshacer.",
        "delete-ok-title": "Borrada",
        "delete-ok-text": "Se ha borrado la ruta",
        "delete-error": "No se ha podido borrar la ruta (puede que ya se haya iniciado)",
    },
    en: {
        "show-on-map": "Show on map",
        "delete": "Delete",
        "delete-question-title": "The route will be deleted",
        "delete-question-text": "The route and its points will be deleted. This cannot be undone.",
        "delete-ok-title": "Deleted",
        "delete-ok-text": "The route has been deleted",
        "delete-error": "The route could not be deleted (it may have already started)",
    },
};

export default translations;
